import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IInstrumentTypeEnum) {
    (function(InstrumentType) {
        InstrumentType["UNKNOWN"] = "UNKNOWN";
        InstrumentType["CHECKING_BANK_ACCOUNT"] = "CHECKING_BANK_ACCOUNT";
        InstrumentType["SAVINGS_BANK_ACCOUNT"] = "SAVINGS_BANK_ACCOUNT";
        InstrumentType["DEBIT_CARD"] = "DEBIT_CARD";
        InstrumentType["CREDIT_CARD"] = "CREDIT_CARD";
        InstrumentType["PREPAID_CARD"] = "PREPAID_CARD";
        InstrumentType["CHEQUE"] = "CHEQUE";
        InstrumentType["PLAID_AUTHORIZATION"] = "PLAID_AUTHORIZATION";
        InstrumentType["DEBIT_OR_CREDIT_CARD"] = "DEBIT_OR_CREDIT_CARD";
        InstrumentType["SEPA"] = "SEPA";
        InstrumentType["SOFORT"] = "SOFORT";
        InstrumentType["IDEAL"] = "IDEAL";
        InstrumentType["BACS"] = "BACS";
        InstrumentType["FAIRE_PAY"] = "FAIRE_PAY";
    })(IInstrumentTypeEnum.InstrumentType || (IInstrumentTypeEnum.InstrumentType = {}));
    IInstrumentTypeEnum.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IInstrumentTypeEnum || (IInstrumentTypeEnum = {}));
export var IInstrumentTypeEnum;
